import { Link } from "react-router-dom";
import { Home, ArrowLeft } from "lucide-react";
import SEOHead from "../components/layout/SEOHead";

const NotFoundPage = () => {
  return (
    <>
      <SEOHead
        title="Page Not Found"
        description="The page you're looking for doesn't exist. Return to the Highwall Lift homepage to explore our panel installation equipment."
        canonicalPath="/404"
      />
      
      <div className="min-h-screen bg-[#0A0A0A] pt-20 flex items-center justify-center">
        <div className="max-w-2xl mx-auto px-6 sm:px-8 text-center py-24">
          <p className="font-mono text-signal-red uppercase tracking-[0.2em] text-sm font-bold mb-4">
            Error 404
          </p>
          <h1 className="font-heading text-6xl sm:text-8xl font-extrabold tracking-tight uppercase text-white mb-6">
            Page Not Found
          </h1>
          <p className="text-xl text-gray-400 mb-10">
            The page you&apos;re looking for doesn&apos;t exist or has been moved. 
            Let&apos;s get you back on track.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link 
              to="/"
              className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-signal-red text-white font-bold uppercase tracking-wide hover:bg-signal-red/90 hover:shadow-[0_0_30px_rgba(255,51,51,0.4)] transition-all duration-300"
              data-testid="404-home-link"
            >
              <Home className="w-5 h-5" />
              Back to Home
            </Link>
            <button 
              onClick={() => window.history.back()}
              className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-white/10 text-white font-bold uppercase tracking-wide border border-white/20 hover:bg-white/20 transition-all duration-300"
              data-testid="404-back-button"
            >
              <ArrowLeft className="w-5 h-5" />
              Go Back
            </button>
          </div>
          
          <div className="mt-16 pt-8 border-t border-white/10">
            <p className="text-gray-500 text-sm mb-4">Looking for something specific?</p>
            <div className="flex flex-wrap gap-4 justify-center">
              <Link to="/#products" className="text-gray-400 hover:text-signal-red transition-colors text-sm">
                Products
              </Link>
              <Link to="/blog" className="text-gray-400 hover:text-signal-red transition-colors text-sm">
                Blog
              </Link>
              <Link to="/#quote" className="text-gray-400 hover:text-signal-red transition-colors text-sm">
                Request Quote
              </Link>
              <Link to="/#contact" className="text-gray-400 hover:text-signal-red transition-colors text-sm">
                Contact Us
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NotFoundPage;
